(() => {
	var windowWidth = window.innerWidth;
	var addedmenuItems = document.querySelectorAll('.usermenu');

	addedmenuItems.forEach(item => {
		const submenu = item.querySelector('.addedmenu__submenu');
		if(submenu) {
			const tempWidth = submenu.offsetWidth;
			const positionLeft = offset(submenu).left;
			const outOfWindowValue = positionLeft + tempWidth;
			const outOfWindowBool = outOfWindowValue > windowWidth ? 'right' : 'left';
			submenu.style.height = '0px';
			item.addEventListener('mouseover', function () {
				const tempHeight = submenu.scrollHeight;
				item.classList.add('show_submenu');
				submenu.style.height = tempHeight + 'px';
				submenu.classList.add(outOfWindowBool);
			});

			item.addEventListener('mouseout', function () {
				item.classList.remove('show_submenu');
				submenu.style.height = '0px';
			});
		}
	});

	function offset(el) {
		const rect = el.getBoundingClientRect();
		const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		
		return { 
			top: rect.top + scrollTop, 
			left: rect.left + scrollLeft 
		};
	}

})();